"use client";
import dynamic from "next/dynamic";
export const Popup = dynamic(() => import("./Popup"));

export * from "./usePopupQueue";
export * from "./popupAtom";
export default Popup;
